// Imports
import styled from "styled-components"

import { Variables, Mixins } from "fajny-react"

const Container = styled.div`
    border: 1px solid ${Variables.Colors.Gray200};
    border-radius: ${Variables.Radiuses.M};
    overflow: hidden;
`

const DemoContainer = styled.div`
    padding: ${Variables.Spacers.M};
    ${Mixins.Grid({
        $gap: "s",
    })}
`

export { Container, DemoContainer }
